// extracted by mini-css-extract-plugin
export default {"PreviewCanvas":"ImageCropper_PreviewCanvas__H+SGH","CropForm":"ImageCropper_CropForm__k2wkO"};